import script from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=ts"

import "./AnimatedLogo.vue?vue&type=style&index=0&id=618701b2&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618701b2"]])

export default __exports__